import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reached',
  templateUrl: './reached.component.html',
  styleUrls: ['./reached.component.scss']
})
export class ReachedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
